module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.5178/img/templates-homepage/customize-website-icon.svg"